<app-header [isQty]="2"></app-header>
<app-sidebar *ngIf="appServiceScreenMobile"></app-sidebar>
<main id="main" class="main" [ngStyle]="{'margin-top': appServiceScreenMobileSmall ? '55px' : '75px'}">
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
